<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Groups</div>
                </div>
                <div class="col-md-3 offset-md-3 text-right center">
                    <button type="submit" class="btn btn-primary btn-fill"
                            @click="createGroup()">Create Group</button>
                </div>
            </div>
            <div class="table-responsive text-center">
                <l-table class="table table-light table-bordered table-hover"
                         :columns="groups.columns" :data="groups.data">
                    <template slot="table-row" v-if="groups.data.length">
                        <tr v-for="(item, index) in groups.data" :key="index">
                            <td>{{item.groupDefinitionId}}</td>
                          <td>{{item.groupTitle}}</td>
                          <td>{{item.groupDescription}}</td>
                          <td>{{item.csvGroupIntetests}}</td>
                          <td>{{item.csvGroupVideoTagsId}}</td>
                          <td>{{item.csvGroupExpertsName}}</td>
                          <td>{{item.csvGroupTrendPlaylistTitle}}</td>
                          <td>{{item.csvGroupArticlesHeading}}</td>
                          <td>
                            <span class="badge badge-success" v-if="item.active != '0'"> Active </span>
                            <span class="badge badge-danger" v-else> Inactive </span>
                          </td>
                          <td>
                            <div class="btn-group" role="group">
                              <button class="btn btn-secondary btn-sm" @click="viewGroup(item)" v-tooltip.top-center="tooltips.view"><i class="fa fa-eye"></i></button>
                              <button class="btn btn-info btn-sm" @click="editGroup(item)" v-tooltip.top-center="tooltips.edit"><i class="fa fa-edit"></i></button>
                            </div>
                          </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const columns = ['GroupId', 'Title', 'Description', 'Interests', 'Tags', 'Experts', 'Trending Playlists', 'TONE Articles', 'Active', 'Operations'];
    export default {
        name: 'Groups',
        components: {
            LTable,
        },
        data() {
        return {
            tooltips: {
                view: 'View',
                edit: 'Edit'
            },
          groups: {
                columns: [...columns],
        data: []
    }
    }
    },
    methods: {
        fetch () {
            this.$store.dispatch('FETCH_GROUPS')
                    .then((res) => {
                        this.groups.data = res;
                        console.log('response', res)
                        console.log("this.groups.data : ", this.groups.data);
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
        },
        viewGroup(item){
            this.$store.commit('SET_SELECTED_GROUP', item);
            this.$router.push({ name: 'Group Detail', params: { id:  item.groupDefinitionId}})
        },
        editGroup(item){
            this.$store.commit('SET_SELECTED_GROUP', item);
            this.$router.push({ name: 'Edit Group', params: { id: item.groupDefinitionId}});
        },
        createGroup(){
            this.$router.push({ name: 'Create Group'})
        },
    },
    created() {
        this.fetch();
    },
    computed:{
        routeName () {
            const {name} = this.$route;
            return this.capitalizeFirstLetter(name);
        }
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Groups/Groups.vue